// src/components/financeiro/ModalHistoricoFinanceiro.jsx
import { useEffect, useState, useCallback } from "react";
import useFinanceiro from "../../hooks/useFinanceiro";
import ModalDetalhesLancamento from "./ModalDetalhesLancamento";
import { formatarMoeda } from "../../utils/formatarMoeda";
import { formatarNomeUpper } from "../../utils/formatadores";

export default function ModalHistoricoFinanceiro({ cliente, onClose }) {
  const { buscarHistoricoCliente, renegociarLancamento } = useFinanceiro(false);
  const [parcelas, setParcelas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lancamentoSelecionado, setLancamentoSelecionado] = useState(null);

  const carregarHistorico = useCallback(async () => {
    if (!cliente?._id) return;
    
    setLoading(true);
    try {
        const dados = await buscarHistoricoCliente(cliente._id);
        setParcelas(dados || []);
    } catch (error) {
        console.error("Erro ao carregar histórico:", error);
    } finally {
        setLoading(false);
    }
    }, [cliente?._id, buscarHistoricoCliente]);

  useEffect(() => {
    carregarHistorico();
  }, [carregarHistorico]);

  const lancamentosAgrupados = Object.values(
    parcelas.reduce((acc, p) => {
      const finId = p.financeiroId?._id || p.financeiroId || "avulso";
      if (!acc[finId]) {
        acc[finId] = {
          _id: finId,
          tipo: p.tipoParcela || (p.totalParcelas > 1 ? "parcelado" : "à vista"),
          valorTotal: 0,
          numeroParcelas: p.totalParcelas || 1,
          descricao: p.descricao,
          parcelas: []
        };
      }
      acc[finId].parcelas.push(p);
      acc[finId].valorTotal += Number(p.valor);
      return acc;
    }, {})
  );

  const handleSalvarEdicao = async (financeiroId, dados) => {
    await renegociarLancamento(financeiroId, dados);
    setLancamentoSelecionado(null);
    carregarHistorico();
  };

  return (
    /* Alterado de "modal-backdrop" para "submodal-overlay" ou "modal-overlay" */
    <div className="submodal-overlay" onClick={onClose}>
      <div 
        className="submodal-content" 
        style={{ maxWidth: "700px", width: "90%" }}
        onClick={(e) => e.stopPropagation()} /* Evita fechar o modal ao clicar dentro dele */
      >
        <div className="modal-header">
          <h3>Histórico Financeiro: {formatarNomeUpper(cliente.nomeCliente) || cliente.nome}</h3>
          <button 
            className="btn-cancel" 
            onClick={onClose}
          >
            Fechar
            </button>
        </div>

        <div className="modal-body" style={{ margin: "15px 0" }}>
          {loading ? (
            <p>Carregando histórico...</p>
          ) : lancamentosAgrupados.length === 0 ? (
            <p>Nenhum histórico financeiro encontrado para este cliente.</p>
          ) : (
            <div className="historico-lista" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {lancamentosAgrupados.map((item) => {
                const pagas = item.parcelas.filter((p) => p.status === "pago").length;
                return (
                  <div
                    key={item._id}
                    onClick={() => setLancamentoSelecionado(item)}
                    style={{
                      padding: "12px",
                      border: "1px solid #e2e8f0",
                      borderRadius: "8px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      backgroundColor: "#f8fafc"
                    }}
                  >
                    <div>
                      <strong>{item.descricao || "Lançamento Financeiro"}</strong>
                      <div style={{ fontSize: "0.85rem", color: "#64748b" }}>
                        Tipo: {item.tipo} • Parcelas: ({pagas}/{item.parcelas.length} pagas)
                      </div>
                    </div>

                    <div style={{ textAlign: "right" }}>
                      <strong style={{ color: "#2563eb" }}>
                        R$ {formatarMoeda(item.valorTotal.toFixed(2))}
                      </strong>
                      <div style={{ fontSize: "0.8rem", color: "#94a3b8" }}>Clique para detalhes ›</div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <hr></hr>

        {lancamentoSelecionado && (
          <ModalDetalhesLancamento
            lancamento={lancamentoSelecionado}
            parcelas={lancamentoSelecionado.parcelas}
            onClose={() => setLancamentoSelecionado(null)}
            onSalvarEdicao={handleSalvarEdicao}
          />
        )}
      </div>
    </div>
  );
}